var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet(obj, member, value, setter);
  },
  get _() {
    return __privateGet(obj, member, getter);
  }
});
var _root, _sticky, _products, _productData, _backgrounds, _backgroundData, _step, _headHold, _tailHold, _length, _startY, _stepHeight, _headHoldHeight, _tailHoldHeight, _activeIndex, _previousActiveIndex, _preferredIndex, _controlsApi, _controlsCleanup, _contentGroup, _slideStatus, _syncedColorScheme, _cursorNavigationCleanup, _mobileCarousel, _desktopCarousel, _desktopCarouselEngine, _mobileMediaQuery, _usesMobileCarousel, _productViewport, _productTrack, _renderedPosition, _renderedHeightCompensation, _currentScrollY, _targetScrollY, _scrubbedScrollY, _lastScrollDirection, _isMeasured, _shouldReduceMotion, _usesNativeScrub, _usesScrollTrigger, _isSnapping, _backgroundTransitionStyle, _backgroundSlideAxis, _carouselLoop, _autoplayEnabled, _autoplayDelay, _autoplayTimer, _autoplayDeadline, _autoplayObserver, _autoplayPauseReasons, _isAutoplayNavigation, _usesFirstSectionHeightCompensation, _currentStickyHeight, _targetStickyHeight, _referenceStickyHeight, _heightCompensationViewportKey, _heightCompensationModeKey, _measureRAF, _scrubRAF, _scrubLastTime, _snapRAF, _snapGeneration, _navigationRAF, _navigationGeneration, _navigationLockTimer, _isNavigationLocked, _scrollStopTimer, _snapDelayTimer, _editorSelectionRAF, _editorSelectedProduct, _editorPreviewIndex, _isEditorScrollSyncing, _isDesignMode, _resizeObserver, _stickyResizeObserver, _intersectionObserver, _reducedMotionQuery, _unbindScroll, _handleScroll, _handleScrollEnd, _handleUserScrollIntent, _handleKeyScrollIntent, _SCFeaturedProductsSlideshowComponent_instances, releaseEditorScrollSync_fn, _handleIntersection, _handleReducedMotionChange, _handleStickyResize, _handleBlockSelect, _handleBlockDeselect, getEditorProductItem_fn, activateEditorProduct_fn, _handleMobileBreakpointChange, setupDesktopCarousel_fn, destroyDesktopCarousel_fn, _handleDesktopCarouselSelect, beginDesktopNavigation_fn, releaseDesktopNavigationLock_fn, setupMobileCarousel_fn, destroyMobileCarousel_fn, _syncMobileSelection, setupControls_fn, destroyControls_fn, setupCursorNavigation_fn, destroyCursorNavigation_fn, setupAutoplay_fn, destroyAutoplay_fn, _handleAutoplayVisibilityChange, setAutoplayPaused_fn, scheduleAutoplay_fn, clearAutoplayTimer_fn, createControlsApi_fn, navigateBy_fn, navigateToIndex_fn, navigateWithoutScroll_fn, cancelNavigationAnimation_fn, _scheduleMeasure, measure_fn, scheduleScrollStopFallback_fn, isWithinTimelineRange_fn, scheduleNativeScrub_fn, _updateNativeScrub, snapToDirectionalCheckpoint_fn, startSnap_fn, finishSnap_fn, cancelSnap_fn, renderAtScroll_fn, renderAtPosition_fn, syncActiveState_fn, syncColorScheme_fn, syncAccessibility_fn, resetSynchronizedState_fn, syncProductColorTransitionTarget_fn, clearMotionStyles_fn, setStyle_fn, clearStyle_fn;
import { E as EmblaCarousel, b as duplicateSlidesForLoop, f as addDotsBtnsAndClickHandlersSSR, a as addPrevNextBtnsClickHandlersSSR } from "./embla-extension-cVbn2auS.js";
import { A as Autoplay } from "./embla-carousel-autoplay.esm-lYa57aZD.js";
import { getScrollState, onScrollFrameUpdate } from "./scroll-dispatcher-BIs-vu0Q.js";
import { initNativeScroll } from "./native-scroll-snap-Cd15iSfl.js";
import { prefersReducedMotion, getThemeSettings } from "./utilities-BFAI3Dmv.js";
import { isMobileAnim } from "./mobile-anim-gate-Btn1wVuD.js";
import "./mobile-autoplay-LQAitT2O.js";
import "./progressive-images-mIwHxxsh.js";
import "./autoplay-progress-BLL6tdZq.js";
import "./waapi-patch-BCt4pEht.js";
import "./cookie-banner-layout-DZP7Q0uT.js";
import "./section-anchor-scroll-Bvm-mXVl.js";
const ROOT_SELECTOR = ".sc-featured-products-slideshow";
const PRODUCT_SELECTOR = ".sc-featured-products-slideshow-product-item";
const BACKGROUND_LAYER_SELECTOR = ".sc-featured-products-slideshow-backgrounds-layer";
const BACKGROUND_SELECTOR = ".sc-featured-products-slideshow-bg-item";
const BACKGROUND_OVERFLOW_SELECTOR = ".sc-featured-products-slideshow-bg-overflow";
const BACKGROUND_MEDIA_SELECTOR = ".sc-featured-products-slideshow-bg";
const STEP_SELECTOR = ".sc-featured-products-slideshow-scroll-step";
const HEAD_HOLD_SELECTOR = ".sc-featured-products-slideshow-timeline-hold--start";
const TAIL_HOLD_SELECTOR = ".sc-featured-products-slideshow-timeline-hold--end";
const CONTROLS_SELECTOR = ".sc-featured-products-slideshow-controls";
const CONTENT_GROUP_SELECTOR = ".sc-featured-products-slideshow-content-group";
const SLIDE_STATUS_SELECTOR = "[data-featured-products-slide-status]";
const PRODUCT_VIEWPORT_SELECTOR = ".sc-featured-products-slideshow-product-inner";
const PRODUCT_TRACK_SELECTOR = ".sc-featured-products-slideshow-product-stack";
const DESKTOP_CAROUSEL_ENGINE_CLASS = "sc-featured-products-slideshow-carousel-engine";
const PRODUCT_COLOR_TRANSITION_CLASS = "is-color-transition-target";
const MOBILE_CAROUSEL_MEDIA_QUERY = "(max-width: 991.98px)";
const DESKTOP_FINE_POINTER_MEDIA_QUERY = "(min-width: 992px) and (hover: hover) and (pointer: fine)";
const CURSOR_NAVIGATION_EXCLUSION_SELECTOR = [
  "[data-cursor-navigation-exclude]",
  "a",
  "button",
  "input",
  "select",
  "textarea",
  "summary",
  "label",
  "video[controls]",
  "audio[controls]",
  '[contenteditable]:not([contenteditable="false"])',
  '[tabindex]:not([tabindex="-1"])',
  '[role="button"]',
  '[role="link"]',
  '[role="checkbox"]',
  '[role="radio"]',
  '[role="switch"]',
  '[role="tab"]',
  "[aria-controls]",
  "[aria-expanded]",
  "[aria-haspopup]",
  "[onclick]",
  "[on\\:click]",
  "[data-action]",
  "[data-toggle]",
  "[data-no-drag]",
  ".embla__snip-dots",
  ".embla__snip-bars",
  ".embla-thumbs"
].join(", ");
const SEGMENT_DWELL_RATIO = 0.2;
const SEGMENT_EDGE_DWELL_RATIO = SEGMENT_DWELL_RATIO / 2;
const SEGMENT_TRANSITION_RATIO = 1 - SEGMENT_DWELL_RATIO;
const NATIVE_SCRUB_STRENGTH = 0.2;
const FRAME_DURATION_MS = 1e3 / 60;
const SCROLL_STOP_FALLBACK_MS = 120;
const SNAP_DELAY_MS = 10;
const SNAP_DURATION_MIN_MS = 100;
const SNAP_DURATION_MAX_MS = 1e3;
const SNAP_CHECKPOINT_EPSILON = 1e-3;
const SLIDESHOW_TRANSITION_DURATION_MS = 1e3;
const DESKTOP_NAVIGATION_LOCK_MS = 450;
const DEFAULT_AUTOPLAY_DELAY_MS = 4e3;
const BACKGROUND_SETTLED_SCALE = 1.02;
const BACKGROUND_STANDARD_ENTRY_SCALE = 1.05;
const BACKGROUND_WIPE_ENTRY_SCALE = 1.4;
const BACKGROUND_TRANSITION_STYLES = /* @__PURE__ */ new Set([
  "slide",
  "fade",
  "scale",
  "vertical",
  "wipe"
]);
const BACKGROUND_CROSSFADE_STYLES = /* @__PURE__ */ new Set([
  "fade",
  "scale",
  "vertical"
]);
const SNAP_SCROLL_KEYS = /* @__PURE__ */ new Set([
  "ArrowDown",
  "ArrowUp",
  "End",
  "Home",
  "PageDown",
  "PageUp",
  " "
]);
const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
const easePower2InOut = (progress) => progress < 0.5 ? 4 * Math.pow(progress, 3) : 1 - Math.pow(-2 * progress + 2, 3) / 2;
const easePower3Out = (progress) => {
  const clampedProgress = clamp(progress, 0, 1);
  return 1 - Math.pow(1 - clampedProgress, 4);
};
const createCubicBezierEasing = (x1, y1, x2, y2) => (progress) => {
  const clampedProgress = clamp(progress, 0, 1);
  if (clampedProgress === 0 || clampedProgress === 1) {
    return clampedProgress;
  }
  let lower = 0;
  let upper = 1;
  let curvePosition = 0.5;
  for (let iteration = 0; iteration < 14; iteration += 1) {
    curvePosition = (lower + upper) / 2;
    const inversePosition2 = 1 - curvePosition;
    const curveX = 3 * inversePosition2 * inversePosition2 * curvePosition * x1 + 3 * inversePosition2 * curvePosition * curvePosition * x2 + curvePosition * curvePosition * curvePosition;
    if (curveX < clampedProgress) {
      lower = curvePosition;
    } else {
      upper = curvePosition;
    }
  }
  const inversePosition = 1 - curvePosition;
  return 3 * inversePosition * inversePosition * curvePosition * y1 + 3 * inversePosition * curvePosition * curvePosition * y2 + curvePosition * curvePosition * curvePosition;
};
const easeSlideshowTransition = createCubicBezierEasing(0.16, 1, 0.3, 1);
const easeSlideshowWipeTransition = createCubicBezierEasing(0.5, 0, 0, 1);
const parseCssLengthToPixels = (value, rootFontSize = 16) => {
  const normalized = value.trim().toLowerCase();
  const parsed = Number.parseFloat(normalized);
  if (!Number.isFinite(parsed)) return null;
  if (normalized.endsWith("rem") || normalized.endsWith("em")) {
    return parsed * rootFontSize;
  }
  if (normalized.endsWith("px") || /^-?\d*\.?\d+$/.test(normalized)) {
    return parsed;
  }
  return null;
};
const easeSegmentProgress = (progress) => {
  const transitionProgress = clamp((progress - SEGMENT_EDGE_DWELL_RATIO) / SEGMENT_TRANSITION_RATIO, 0, 1);
  return easePower2InOut(transitionProgress);
};
const getTimelinePosition = (masterProgress, itemCount) => {
  const segmentCount = Math.max(0, itemCount - 1);
  if (segmentCount === 0) return 0;
  const linearPosition = clamp(masterProgress, 0, 1) * segmentCount;
  const segmentIndex = Math.min(Math.floor(linearPosition), segmentCount - 1);
  const segmentProgress = linearPosition - segmentIndex;
  return segmentIndex + easeSegmentProgress(segmentProgress);
};
class SCFeaturedProductsSlideshowComponent extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _SCFeaturedProductsSlideshowComponent_instances);
    __privateAdd(this, _root, null);
    __privateAdd(this, _sticky, null);
    __privateAdd(this, _products, []);
    __privateAdd(this, _productData, []);
    __privateAdd(this, _backgrounds, []);
    __privateAdd(this, _backgroundData, []);
    __privateAdd(this, _step, null);
    __privateAdd(this, _headHold, null);
    __privateAdd(this, _tailHold, null);
    __privateAdd(this, _length, 0);
    __privateAdd(this, _startY, 0);
    __privateAdd(this, _stepHeight, 1);
    __privateAdd(this, _headHoldHeight, 0);
    __privateAdd(this, _tailHoldHeight, 0);
    __privateAdd(this, _activeIndex, -1);
    __privateAdd(this, _previousActiveIndex, 0);
    __privateAdd(this, _preferredIndex, 0);
    __privateAdd(this, _controlsApi, null);
    __privateAdd(this, _controlsCleanup, []);
    __privateAdd(this, _contentGroup, null);
    __privateAdd(this, _slideStatus, null);
    __privateAdd(this, _syncedColorScheme, null);
    __privateAdd(this, _cursorNavigationCleanup, null);
    __privateAdd(this, _mobileCarousel, null);
    __privateAdd(this, _desktopCarousel, null);
    __privateAdd(this, _desktopCarouselEngine, null);
    __privateAdd(this, _mobileMediaQuery, null);
    __privateAdd(this, _usesMobileCarousel, false);
    __privateAdd(this, _productViewport, null);
    __privateAdd(this, _productTrack, null);
    __privateAdd(this, _renderedPosition, null);
    __privateAdd(this, _renderedHeightCompensation, null);
    __privateAdd(this, _currentScrollY, 0);
    __privateAdd(this, _targetScrollY, 0);
    __privateAdd(this, _scrubbedScrollY, 0);
    __privateAdd(this, _lastScrollDirection, null);
    __privateAdd(this, _isMeasured, false);
    __privateAdd(this, _shouldReduceMotion, false);
    __privateAdd(this, _usesNativeScrub, false);
    __privateAdd(this, _usesScrollTrigger, true);
    __privateAdd(this, _isSnapping, false);
    __privateAdd(this, _backgroundTransitionStyle, "slide");
    __privateAdd(this, _backgroundSlideAxis, "horizontal");
    __privateAdd(this, _carouselLoop, false);
    __privateAdd(this, _autoplayEnabled, false);
    __privateAdd(this, _autoplayDelay, DEFAULT_AUTOPLAY_DELAY_MS);
    __privateAdd(this, _autoplayTimer, 0);
    __privateAdd(this, _autoplayDeadline, 0);
    __privateAdd(this, _autoplayObserver, null);
    __privateAdd(this, _autoplayPauseReasons, /* @__PURE__ */ new Set());
    __privateAdd(this, _isAutoplayNavigation, false);
    __privateAdd(this, _usesFirstSectionHeightCompensation, false);
    __privateAdd(this, _currentStickyHeight, 0);
    __privateAdd(this, _targetStickyHeight, 0);
    __privateAdd(this, _referenceStickyHeight, 0);
    __privateAdd(this, _heightCompensationViewportKey, "");
    __privateAdd(this, _heightCompensationModeKey, "");
    __privateAdd(this, _measureRAF, 0);
    __privateAdd(this, _scrubRAF, 0);
    __privateAdd(this, _scrubLastTime, 0);
    __privateAdd(this, _snapRAF, 0);
    __privateAdd(this, _snapGeneration, 0);
    __privateAdd(this, _navigationRAF, 0);
    __privateAdd(this, _navigationGeneration, 0);
    __privateAdd(this, _navigationLockTimer, 0);
    __privateAdd(this, _isNavigationLocked, false);
    __privateAdd(this, _scrollStopTimer, 0);
    __privateAdd(this, _snapDelayTimer, 0);
    __privateAdd(this, _editorSelectionRAF, 0);
    __privateAdd(this, _editorSelectedProduct, null);
    __privateAdd(this, _editorPreviewIndex, null);
    __privateAdd(this, _isEditorScrollSyncing, false);
    __privateAdd(this, _isDesignMode, false);
    __privateAdd(this, _resizeObserver, null);
    __privateAdd(this, _stickyResizeObserver, null);
    __privateAdd(this, _intersectionObserver, null);
    __privateAdd(this, _reducedMotionQuery, null);
    __privateAdd(this, _unbindScroll, null);
    __privateAdd(this, _handleScroll, ({ scrollY, direction }) => {
      __privateSet(this, _currentScrollY, scrollY);
      __privateSet(this, _targetScrollY, scrollY);
      if (direction === "down" || direction === "up") {
        __privateSet(this, _lastScrollDirection, direction);
      }
      const isWithinTimeline = __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, isWithinTimelineRange_fn).call(this, scrollY);
      if (__privateGet(this, _isEditorScrollSyncing)) {
        clearTimeout(__privateGet(this, _scrollStopTimer));
        clearTimeout(__privateGet(this, _snapDelayTimer));
        __privateSet(this, _scrollStopTimer, 0);
        __privateSet(this, _snapDelayTimer, 0);
      } else if (!__privateGet(this, _isSnapping) && isWithinTimeline) {
        clearTimeout(__privateGet(this, _snapDelayTimer));
        __privateSet(this, _snapDelayTimer, 0);
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, scheduleScrollStopFallback_fn).call(this);
      } else if (!__privateGet(this, _isSnapping)) {
        clearTimeout(__privateGet(this, _scrollStopTimer));
        clearTimeout(__privateGet(this, _snapDelayTimer));
        __privateSet(this, _scrollStopTimer, 0);
        __privateSet(this, _snapDelayTimer, 0);
      }
      if (!__privateGet(this, _isMeasured)) return;
      if (__privateGet(this, _isEditorScrollSyncing)) {
        if (__privateGet(this, _scrubRAF)) cancelAnimationFrame(__privateGet(this, _scrubRAF));
        __privateSet(this, _scrubRAF, 0);
        __privateSet(this, _scrubbedScrollY, scrollY);
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtScroll_fn).call(this, scrollY);
        return;
      }
      if (__privateGet(this, _usesNativeScrub) && !__privateGet(this, _shouldReduceMotion) && (isWithinTimeline || __privateGet(this, _isSnapping))) {
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, scheduleNativeScrub_fn).call(this);
      } else {
        if (__privateGet(this, _scrubRAF)) cancelAnimationFrame(__privateGet(this, _scrubRAF));
        __privateSet(this, _scrubRAF, 0);
        __privateSet(this, _scrubbedScrollY, scrollY);
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtScroll_fn).call(this, scrollY);
      }
    });
    __privateAdd(this, _handleScrollEnd, () => {
      if (__privateGet(this, _isEditorScrollSyncing) || __privateGet(this, _isSnapping) || __privateGet(this, _shouldReduceMotion)) return;
      clearTimeout(__privateGet(this, _scrollStopTimer));
      clearTimeout(__privateGet(this, _snapDelayTimer));
      __privateSet(this, _scrollStopTimer, 0);
      __privateSet(this, _snapDelayTimer, setTimeout(() => {
        __privateSet(this, _snapDelayTimer, 0);
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, snapToDirectionalCheckpoint_fn).call(this);
      }, SNAP_DELAY_MS));
    });
    __privateAdd(this, _handleUserScrollIntent, () => {
      if (__privateGet(this, _isDesignMode)) __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, releaseEditorScrollSync_fn).call(this);
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, cancelSnap_fn).call(this);
    });
    __privateAdd(this, _handleKeyScrollIntent, (event) => {
      if (!SNAP_SCROLL_KEYS.has(event.key)) return;
      if (__privateGet(this, _isDesignMode)) __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, releaseEditorScrollSync_fn).call(this);
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, cancelSnap_fn).call(this);
    });
    __privateAdd(this, _handleIntersection, (entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        __privateGet(this, _scheduleMeasure).call(this);
      }
    });
    __privateAdd(this, _handleReducedMotionChange, () => {
      var _a;
      __privateSet(this, _shouldReduceMotion, prefersReducedMotion());
      if (__privateGet(this, _shouldReduceMotion)) {
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, cancelSnap_fn).call(this);
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, cancelNavigationAnimation_fn).call(this);
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, releaseDesktopNavigationLock_fn).call(this);
      }
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, scheduleAutoplay_fn).call(this);
      if (__privateGet(this, _scrubRAF)) cancelAnimationFrame(__privateGet(this, _scrubRAF));
      __privateSet(this, _scrubRAF, 0);
      if (__privateGet(this, _usesMobileCarousel)) {
        (_a = __privateGet(this, _mobileCarousel)) == null ? void 0 : _a.reInit();
        __privateGet(this, _syncMobileSelection).call(this);
        return;
      }
      if (!__privateGet(this, _usesScrollTrigger)) {
        const selectedIndex = __privateGet(this, _desktopCarousel) ? (__privateGet(this, _desktopCarousel).selectedScrollSnap() % __privateGet(this, _length) + __privateGet(this, _length)) % __privateGet(this, _length) : clamp(__privateGet(this, _activeIndex), 0, __privateGet(this, _length) - 1);
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtPosition_fn).call(this, selectedIndex);
        return;
      }
      __privateSet(this, _scrubbedScrollY, __privateGet(this, _currentScrollY));
      __privateSet(this, _targetScrollY, __privateGet(this, _currentScrollY));
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtScroll_fn).call(this, __privateGet(this, _currentScrollY));
    });
    __privateAdd(this, _handleStickyResize, (entries) => {
      var _a;
      const entry = entries.find(({ target }) => target === __privateGet(this, _sticky));
      if (!entry) return;
      const borderBox = ((_a = entry.borderBoxSize) == null ? void 0 : _a[0]) ?? entry.borderBoxSize;
      const height = (borderBox == null ? void 0 : borderBox.blockSize) ?? entry.contentRect.height;
      if (!Number.isFinite(height) || Math.abs(height - __privateGet(this, _currentStickyHeight)) < 0.01) {
        return;
      }
      __privateSet(this, _currentStickyHeight, height);
      __privateSet(this, _referenceStickyHeight, Math.max(
        __privateGet(this, _referenceStickyHeight),
        __privateGet(this, _currentStickyHeight),
        __privateGet(this, _targetStickyHeight)
      ));
      if (__privateGet(this, _isMeasured)) {
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtScroll_fn).call(this, __privateGet(this, _usesNativeScrub) ? __privateGet(this, _scrubbedScrollY) : __privateGet(this, _currentScrollY));
      }
    });
    __privateAdd(this, _handleBlockSelect, (event) => {
      if (!__privateGet(this, _isDesignMode)) return;
      const productItem = __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, getEditorProductItem_fn).call(this, event);
      if (!productItem) return;
      const index = Number(productItem.dataset.index);
      if (!Number.isInteger(index) || index < 0 || index >= __privateGet(this, _length)) return;
      __privateSet(this, _editorSelectedProduct, productItem);
      __privateSet(this, _editorPreviewIndex, index);
      __privateSet(this, _isEditorScrollSyncing, __privateGet(this, _isDesignMode) && __privateGet(this, _usesScrollTrigger));
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setAutoplayPaused_fn).call(this, "editor", true);
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, activateEditorProduct_fn).call(this, index);
      if (__privateGet(this, _editorSelectionRAF)) cancelAnimationFrame(__privateGet(this, _editorSelectionRAF));
      __privateSet(this, _editorSelectionRAF, requestAnimationFrame(() => {
        __privateSet(this, _editorSelectionRAF, 0);
        if (!this.isConnected || __privateGet(this, _editorSelectedProduct) !== productItem) return;
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, activateEditorProduct_fn).call(this, index);
      }));
    });
    __privateAdd(this, _handleBlockDeselect, (event) => {
      if (!__privateGet(this, _isDesignMode)) return;
      const productItem = __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, getEditorProductItem_fn).call(this, event);
      if (!productItem || productItem !== __privateGet(this, _editorSelectedProduct)) return;
      __privateSet(this, _editorSelectedProduct, null);
      if (__privateGet(this, _editorSelectionRAF)) cancelAnimationFrame(__privateGet(this, _editorSelectionRAF));
      __privateSet(this, _editorSelectionRAF, 0);
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setAutoplayPaused_fn).call(this, "editor", false);
    });
    __privateAdd(this, _handleMobileBreakpointChange, ({ matches }) => {
      if (matches === __privateGet(this, _usesMobileCarousel) || !this.isConnected) return;
      const editorSelectedProduct = __privateGet(this, _editorSelectedProduct);
      const editorPreviewIndex = __privateGet(this, _editorPreviewIndex);
      const isEditorScrollSyncing = __privateGet(this, _isEditorScrollSyncing);
      this.disconnectedCallback();
      if (!this.isConnected) return;
      this.connectedCallback();
      const editorSelectedIndex = __privateGet(this, _products).indexOf(editorSelectedProduct);
      const restoredEditorIndex = editorSelectedIndex >= 0 ? editorSelectedIndex : isEditorScrollSyncing && Number.isInteger(editorPreviewIndex) ? editorPreviewIndex : -1;
      if (restoredEditorIndex < 0 || restoredEditorIndex >= __privateGet(this, _length)) return;
      __privateSet(this, _editorSelectedProduct, editorSelectedIndex >= 0 ? editorSelectedProduct : null);
      __privateSet(this, _editorPreviewIndex, restoredEditorIndex);
      __privateSet(this, _isEditorScrollSyncing, __privateGet(this, _isDesignMode) && __privateGet(this, _usesScrollTrigger) && isEditorScrollSyncing);
      if (__privateGet(this, _editorSelectedProduct)) __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setAutoplayPaused_fn).call(this, "editor", true);
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, activateEditorProduct_fn).call(this, restoredEditorIndex);
    });
    __privateAdd(this, _handleDesktopCarouselSelect, (carousel) => {
      const selectedIndex = (carousel.selectedScrollSnap() % __privateGet(this, _length) + __privateGet(this, _length)) % __privateGet(this, _length);
      const previousIndex = (carousel.previousScrollSnap() % __privateGet(this, _length) + __privateGet(this, _length)) % __privateGet(this, _length);
      const wrapDirection = previousIndex === __privateGet(this, _length) - 1 && selectedIndex === 0 ? 1 : previousIndex === 0 && selectedIndex === __privateGet(this, _length) - 1 ? -1 : 0;
      const renderedPosition = __privateGet(this, _renderedPosition) ?? previousIndex;
      const isOutsideCanonicalRange = renderedPosition < -1e-4 || renderedPosition > __privateGet(this, _length) - 1 + 1e-4;
      const needsWrapCommit = wrapDirection > 0 && renderedPosition < __privateGet(this, _length) - 1 - 1e-4 || wrapDirection < 0 && renderedPosition > 1e-4;
      const needsCanonicalCommit = wrapDirection === 0 && isOutsideCanonicalRange;
      if (needsWrapCommit || needsCanonicalCommit) {
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, cancelNavigationAnimation_fn).call(this);
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtPosition_fn).call(this, previousIndex);
      }
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, navigateWithoutScroll_fn).call(this, selectedIndex, false, wrapDirection, __privateGet(this, _isAutoplayNavigation));
    });
    __privateAdd(this, _syncMobileSelection, () => {
      var _a;
      const selectedIndex = clamp(((_a = __privateGet(this, _mobileCarousel)) == null ? void 0 : _a.selectedScrollSnap()) ?? 0, 0, __privateGet(this, _length) - 1);
      const shouldAnnounce = __privateGet(this, _activeIndex) >= 0 && __privateGet(this, _activeIndex) !== selectedIndex;
      __privateSet(this, _previousActiveIndex, __privateGet(this, _activeIndex) < 0 ? selectedIndex : __privateGet(this, _activeIndex));
      __privateSet(this, _activeIndex, selectedIndex);
      __privateSet(this, _preferredIndex, selectedIndex);
      if (__privateGet(this, _isEditorScrollSyncing)) __privateSet(this, _editorPreviewIndex, selectedIndex);
      __privateGet(this, _products).forEach((productItem, index) => {
        const isActive = index === selectedIndex;
        productItem.classList.toggle("is-active", isActive);
        productItem.inert = !isActive;
        if (isActive) {
          productItem.removeAttribute("aria-hidden");
        } else {
          productItem.setAttribute("aria-hidden", "true");
        }
      });
      __privateGet(this, _backgrounds).forEach((backgroundItem, index) => {
        backgroundItem.classList.toggle("is-active", index === selectedIndex);
      });
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, syncColorScheme_fn).call(this, selectedIndex);
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, syncAccessibility_fn).call(this, selectedIndex, shouldAnnounce);
    });
    __privateAdd(this, _handleAutoplayVisibilityChange, () => {
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, scheduleAutoplay_fn).call(this);
    });
    __privateAdd(this, _scheduleMeasure, () => {
      if (__privateGet(this, _measureRAF)) return;
      __privateSet(this, _measureRAF, requestAnimationFrame(() => {
        __privateSet(this, _measureRAF, 0);
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, measure_fn).call(this);
      }));
    });
    __privateAdd(this, _updateNativeScrub, (timestamp) => {
      __privateSet(this, _scrubRAF, 0);
      if (!__privateGet(this, _isMeasured) || !__privateGet(this, _usesNativeScrub)) return;
      const elapsed = clamp(timestamp - __privateGet(this, _scrubLastTime), 0, 64);
      __privateSet(this, _scrubLastTime, timestamp);
      const frameScale = elapsed / FRAME_DURATION_MS;
      const alpha = 1 - Math.pow(1 - NATIVE_SCRUB_STRENGTH, frameScale);
      const remaining = __privateGet(this, _targetScrollY) - __privateGet(this, _scrubbedScrollY);
      if (Math.abs(remaining) < 0.1) {
        __privateSet(this, _scrubbedScrollY, __privateGet(this, _targetScrollY));
        __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtScroll_fn).call(this, __privateGet(this, _scrubbedScrollY));
        return;
      }
      __privateSet(this, _scrubbedScrollY, __privateGet(this, _scrubbedScrollY) + remaining * alpha);
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtScroll_fn).call(this, __privateGet(this, _scrubbedScrollY));
      __privateSet(this, _scrubRAF, requestAnimationFrame(__privateGet(this, _updateNativeScrub)));
    });
  }
  connectedCallback() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
    __privateSet(this, _isMeasured, false);
    __privateSet(this, _renderedPosition, null);
    __privateSet(this, _renderedHeightCompensation, null);
    __privateSet(this, _isSnapping, false);
    __privateSet(this, _isNavigationLocked, false);
    __privateSet(this, _activeIndex, -1);
    __privateSet(this, _previousActiveIndex, 0);
    __privateSet(this, _syncedColorScheme, null);
    __privateSet(this, _headHoldHeight, 0);
    __privateSet(this, _tailHoldHeight, 0);
    __privateSet(this, _currentStickyHeight, 0);
    __privateSet(this, _targetStickyHeight, 0);
    __privateSet(this, _referenceStickyHeight, 0);
    __privateSet(this, _heightCompensationViewportKey, "");
    __privateSet(this, _heightCompensationModeKey, "");
    __privateSet(this, _mobileMediaQuery, window.matchMedia(MOBILE_CAROUSEL_MEDIA_QUERY));
    __privateSet(this, _usesMobileCarousel, __privateGet(this, _mobileMediaQuery).matches);
    __privateSet(this, _root, this.closest(ROOT_SELECTOR));
    __privateSet(this, _usesScrollTrigger, ((_a = __privateGet(this, _root)) == null ? void 0 : _a.dataset.scrollTrigger) !== "false");
    const configuredAutoplayDelay = Number.parseFloat(((_b = __privateGet(this, _root)) == null ? void 0 : _b.dataset.autoplayDelay) ?? "");
    __privateSet(this, _carouselLoop, !__privateGet(this, _usesScrollTrigger) || __privateGet(this, _usesMobileCarousel));
    __privateSet(this, _autoplayEnabled, Boolean(
      ((_c = __privateGet(this, _root)) == null ? void 0 : _c.dataset.autoplay) === "true" && __privateGet(this, _carouselLoop) && !__privateGet(this, _usesMobileCarousel)
    ));
    __privateSet(this, _autoplayDelay, Number.isFinite(configuredAutoplayDelay) ? Math.max(1e3, configuredAutoplayDelay) : DEFAULT_AUTOPLAY_DELAY_MS);
    __privateGet(this, _autoplayPauseReasons).clear();
    __privateSet(this, _isAutoplayNavigation, false);
    __privateSet(this, _editorSelectedProduct, null);
    __privateSet(this, _editorPreviewIndex, null);
    __privateSet(this, _isEditorScrollSyncing, false);
    __privateSet(this, _isDesignMode, ((_d = window.Shopify) == null ? void 0 : _d.designMode) === true);
    __privateSet(this, _sticky, (_e = __privateGet(this, _root)) == null ? void 0 : _e.querySelector(".sc-featured-products-slideshow-sticky"));
    __privateSet(this, _backgroundSlideAxis, ((_f = __privateGet(this, _sticky)) == null ? void 0 : _f.dataset.backgroundSlideAxis) === "vertical" ? "vertical" : "horizontal");
    __privateSet(this, _products, __privateGet(this, _root) ? [...__privateGet(this, _root).querySelectorAll(PRODUCT_SELECTOR)] : []);
    __privateSet(this, _productViewport, (_g = __privateGet(this, _root)) == null ? void 0 : _g.querySelector(PRODUCT_VIEWPORT_SELECTOR));
    __privateSet(this, _productTrack, (_h = __privateGet(this, _root)) == null ? void 0 : _h.querySelector(PRODUCT_TRACK_SELECTOR));
    __privateSet(this, _contentGroup, (_i = __privateGet(this, _root)) == null ? void 0 : _i.querySelector(CONTENT_GROUP_SELECTOR));
    __privateSet(this, _slideStatus, (_j = __privateGet(this, _root)) == null ? void 0 : _j.querySelector(SLIDE_STATUS_SELECTOR));
    __privateSet(this, _backgrounds, __privateGet(this, _root) ? [...__privateGet(this, _root).querySelectorAll(BACKGROUND_SELECTOR)] : []);
    __privateSet(this, _backgroundData, __privateGet(this, _backgrounds).map((element) => ({
      element,
      overflow: element.querySelector(BACKGROUND_OVERFLOW_SELECTOR),
      media: element.querySelector(BACKGROUND_MEDIA_SELECTOR),
      parallax: element.querySelector('media-bg-component[data-parallax="true"]')
    })));
    const backgroundLayer = (_k = __privateGet(this, _root)) == null ? void 0 : _k.querySelector(BACKGROUND_LAYER_SELECTOR);
    const configuredBackgroundTransition = backgroundLayer == null ? void 0 : backgroundLayer.dataset.backgroundTransitionStyle;
    __privateSet(this, _backgroundTransitionStyle, BACKGROUND_TRANSITION_STYLES.has(configuredBackgroundTransition) ? configuredBackgroundTransition : "slide");
    __privateSet(this, _productData, __privateGet(this, _products).map((element) => ({
      element,
      media: element.querySelector(".sc-featured-products-slideshow-product-media"),
      info: element.querySelector(".sc-featured-products-slideshow-product-info")
    })));
    __privateSet(this, _step, ((_l = __privateGet(this, _root)) == null ? void 0 : _l.querySelector(STEP_SELECTOR)) ?? null);
    __privateSet(this, _headHold, ((_m = __privateGet(this, _root)) == null ? void 0 : _m.querySelector(HEAD_HOLD_SELECTOR)) ?? null);
    __privateSet(this, _tailHold, ((_n = __privateGet(this, _root)) == null ? void 0 : _n.querySelector(TAIL_HOLD_SELECTOR)) ?? null);
    __privateSet(this, _length, Math.min(__privateGet(this, _products).length, __privateGet(this, _backgrounds).length));
    __privateSet(this, _shouldReduceMotion, prefersReducedMotion());
    __privateSet(this, _usesNativeScrub, !getThemeSettings().useSmoothScroll);
    const sectionElement = (_o = __privateGet(this, _root)) == null ? void 0 : _o.closest(".shopify-section");
    const firstSection = document.querySelector("#MainContent > .shopify-section:first-child");
    __privateSet(this, _usesFirstSectionHeightCompensation, Boolean(
      !__privateGet(this, _usesMobileCarousel) && __privateGet(this, _usesScrollTrigger) && sectionElement && sectionElement === firstSection
    ));
    if (!__privateGet(this, _root) || !__privateGet(this, _sticky) || __privateGet(this, _length) === 0 || !__privateGet(this, _usesMobileCarousel) && __privateGet(this, _usesScrollTrigger) && !__privateGet(this, _step)) {
      return;
    }
    __privateSet(this, _reducedMotionQuery, window.matchMedia("(prefers-reduced-motion: reduce)"));
    __privateGet(this, _reducedMotionQuery).addEventListener("change", __privateGet(this, _handleReducedMotionChange));
    if (__privateGet(this, _isDesignMode)) {
      document.addEventListener("shopify:block:select", __privateGet(this, _handleBlockSelect));
      document.addEventListener("shopify:block:deselect", __privateGet(this, _handleBlockDeselect));
    }
    __privateGet(this, _mobileMediaQuery).addEventListener("change", __privateGet(this, _handleMobileBreakpointChange));
    if (__privateGet(this, _usesMobileCarousel)) {
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setupMobileCarousel_fn).call(this);
      return;
    }
    if (!__privateGet(this, _usesScrollTrigger)) {
      __privateSet(this, _isMeasured, true);
      __privateSet(this, _currentScrollY, 0);
      __privateSet(this, _targetScrollY, 0);
      __privateSet(this, _scrubbedScrollY, 0);
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtPosition_fn).call(this, clamp(__privateGet(this, _preferredIndex), 0, __privateGet(this, _length) - 1));
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setupDesktopCarousel_fn).call(this);
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setupControls_fn).call(this, __privateGet(this, _desktopCarousel), __privateGet(this, _length));
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setupCursorNavigation_fn).call(this);
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setupAutoplay_fn).call(this);
      return;
    }
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setupControls_fn).call(this);
    window.addEventListener("topbar:layout-change", __privateGet(this, _scheduleMeasure));
    window.addEventListener("sticky-viewport:consumer-state-change", __privateGet(this, _scheduleMeasure));
    window.addEventListener("scrollend", __privateGet(this, _handleScrollEnd), {
      passive: true
    });
    window.addEventListener("wheel", __privateGet(this, _handleUserScrollIntent), {
      passive: true
    });
    window.addEventListener("touchstart", __privateGet(this, _handleUserScrollIntent), {
      passive: true
    });
    window.addEventListener("keydown", __privateGet(this, _handleKeyScrollIntent));
    __privateSet(this, _resizeObserver, new ResizeObserver(__privateGet(this, _scheduleMeasure)));
    __privateGet(this, _resizeObserver).observe(__privateGet(this, _root));
    if (__privateGet(this, _usesFirstSectionHeightCompensation)) {
      __privateSet(this, _stickyResizeObserver, new ResizeObserver(__privateGet(this, _handleStickyResize)));
      __privateGet(this, _stickyResizeObserver).observe(__privateGet(this, _sticky));
    }
    __privateSet(this, _intersectionObserver, new IntersectionObserver(__privateGet(this, _handleIntersection), { rootMargin: "100% 0px" }));
    __privateGet(this, _intersectionObserver).observe(__privateGet(this, _root));
    const initialScrollState = getScrollState();
    __privateSet(this, _currentScrollY, initialScrollState.scrollY);
    __privateSet(this, _targetScrollY, initialScrollState.scrollY);
    __privateSet(this, _scrubbedScrollY, initialScrollState.scrollY);
    __privateSet(this, _lastScrollDirection, initialScrollState.direction);
    __privateSet(this, _unbindScroll, onScrollFrameUpdate(__privateGet(this, _handleScroll)));
    __privateGet(this, _scheduleMeasure).call(this);
  }
  disconnectedCallback() {
    var _a, _b, _c, _d, _e, _f;
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, cancelSnap_fn).call(this);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, cancelNavigationAnimation_fn).call(this);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, destroyAutoplay_fn).call(this);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, resetSynchronizedState_fn).call(this);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, destroyControls_fn).call(this);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, destroyCursorNavigation_fn).call(this);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, destroyDesktopCarousel_fn).call(this);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, destroyMobileCarousel_fn).call(this);
    (_a = __privateGet(this, _unbindScroll)) == null ? void 0 : _a.call(this);
    __privateSet(this, _unbindScroll, null);
    (_b = __privateGet(this, _resizeObserver)) == null ? void 0 : _b.disconnect();
    __privateSet(this, _resizeObserver, null);
    (_c = __privateGet(this, _stickyResizeObserver)) == null ? void 0 : _c.disconnect();
    __privateSet(this, _stickyResizeObserver, null);
    (_d = __privateGet(this, _intersectionObserver)) == null ? void 0 : _d.disconnect();
    __privateSet(this, _intersectionObserver, null);
    (_e = __privateGet(this, _reducedMotionQuery)) == null ? void 0 : _e.removeEventListener("change", __privateGet(this, _handleReducedMotionChange));
    __privateSet(this, _reducedMotionQuery, null);
    (_f = __privateGet(this, _mobileMediaQuery)) == null ? void 0 : _f.removeEventListener("change", __privateGet(this, _handleMobileBreakpointChange));
    __privateSet(this, _mobileMediaQuery, null);
    document.removeEventListener("shopify:block:select", __privateGet(this, _handleBlockSelect));
    document.removeEventListener("shopify:block:deselect", __privateGet(this, _handleBlockDeselect));
    window.removeEventListener("topbar:layout-change", __privateGet(this, _scheduleMeasure));
    window.removeEventListener("sticky-viewport:consumer-state-change", __privateGet(this, _scheduleMeasure));
    window.removeEventListener("scrollend", __privateGet(this, _handleScrollEnd));
    window.removeEventListener("wheel", __privateGet(this, _handleUserScrollIntent));
    window.removeEventListener("touchstart", __privateGet(this, _handleUserScrollIntent));
    window.removeEventListener("keydown", __privateGet(this, _handleKeyScrollIntent));
    if (__privateGet(this, _measureRAF)) cancelAnimationFrame(__privateGet(this, _measureRAF));
    __privateSet(this, _measureRAF, 0);
    if (__privateGet(this, _scrubRAF)) cancelAnimationFrame(__privateGet(this, _scrubRAF));
    __privateSet(this, _scrubRAF, 0);
    if (__privateGet(this, _editorSelectionRAF)) cancelAnimationFrame(__privateGet(this, _editorSelectionRAF));
    __privateSet(this, _editorSelectionRAF, 0);
    __privateSet(this, _editorSelectedProduct, null);
    __privateSet(this, _editorPreviewIndex, null);
    __privateSet(this, _isEditorScrollSyncing, false);
    clearTimeout(__privateGet(this, _scrollStopTimer));
    clearTimeout(__privateGet(this, _snapDelayTimer));
    __privateSet(this, _scrollStopTimer, 0);
    __privateSet(this, _snapDelayTimer, 0);
  }
}
_root = new WeakMap();
_sticky = new WeakMap();
_products = new WeakMap();
_productData = new WeakMap();
_backgrounds = new WeakMap();
_backgroundData = new WeakMap();
_step = new WeakMap();
_headHold = new WeakMap();
_tailHold = new WeakMap();
_length = new WeakMap();
_startY = new WeakMap();
_stepHeight = new WeakMap();
_headHoldHeight = new WeakMap();
_tailHoldHeight = new WeakMap();
_activeIndex = new WeakMap();
_previousActiveIndex = new WeakMap();
_preferredIndex = new WeakMap();
_controlsApi = new WeakMap();
_controlsCleanup = new WeakMap();
_contentGroup = new WeakMap();
_slideStatus = new WeakMap();
_syncedColorScheme = new WeakMap();
_cursorNavigationCleanup = new WeakMap();
_mobileCarousel = new WeakMap();
_desktopCarousel = new WeakMap();
_desktopCarouselEngine = new WeakMap();
_mobileMediaQuery = new WeakMap();
_usesMobileCarousel = new WeakMap();
_productViewport = new WeakMap();
_productTrack = new WeakMap();
_renderedPosition = new WeakMap();
_renderedHeightCompensation = new WeakMap();
_currentScrollY = new WeakMap();
_targetScrollY = new WeakMap();
_scrubbedScrollY = new WeakMap();
_lastScrollDirection = new WeakMap();
_isMeasured = new WeakMap();
_shouldReduceMotion = new WeakMap();
_usesNativeScrub = new WeakMap();
_usesScrollTrigger = new WeakMap();
_isSnapping = new WeakMap();
_backgroundTransitionStyle = new WeakMap();
_backgroundSlideAxis = new WeakMap();
_carouselLoop = new WeakMap();
_autoplayEnabled = new WeakMap();
_autoplayDelay = new WeakMap();
_autoplayTimer = new WeakMap();
_autoplayDeadline = new WeakMap();
_autoplayObserver = new WeakMap();
_autoplayPauseReasons = new WeakMap();
_isAutoplayNavigation = new WeakMap();
_usesFirstSectionHeightCompensation = new WeakMap();
_currentStickyHeight = new WeakMap();
_targetStickyHeight = new WeakMap();
_referenceStickyHeight = new WeakMap();
_heightCompensationViewportKey = new WeakMap();
_heightCompensationModeKey = new WeakMap();
_measureRAF = new WeakMap();
_scrubRAF = new WeakMap();
_scrubLastTime = new WeakMap();
_snapRAF = new WeakMap();
_snapGeneration = new WeakMap();
_navigationRAF = new WeakMap();
_navigationGeneration = new WeakMap();
_navigationLockTimer = new WeakMap();
_isNavigationLocked = new WeakMap();
_scrollStopTimer = new WeakMap();
_snapDelayTimer = new WeakMap();
_editorSelectionRAF = new WeakMap();
_editorSelectedProduct = new WeakMap();
_editorPreviewIndex = new WeakMap();
_isEditorScrollSyncing = new WeakMap();
_isDesignMode = new WeakMap();
_resizeObserver = new WeakMap();
_stickyResizeObserver = new WeakMap();
_intersectionObserver = new WeakMap();
_reducedMotionQuery = new WeakMap();
_unbindScroll = new WeakMap();
_handleScroll = new WeakMap();
_handleScrollEnd = new WeakMap();
_handleUserScrollIntent = new WeakMap();
_handleKeyScrollIntent = new WeakMap();
_SCFeaturedProductsSlideshowComponent_instances = new WeakSet();
releaseEditorScrollSync_fn = function() {
  if (!__privateGet(this, _isEditorScrollSyncing)) return;
  __privateSet(this, _isEditorScrollSyncing, false);
  __privateSet(this, _editorPreviewIndex, null);
  clearTimeout(__privateGet(this, _scrollStopTimer));
  clearTimeout(__privateGet(this, _snapDelayTimer));
  __privateSet(this, _scrollStopTimer, 0);
  __privateSet(this, _snapDelayTimer, 0);
};
_handleIntersection = new WeakMap();
_handleReducedMotionChange = new WeakMap();
_handleStickyResize = new WeakMap();
_handleBlockSelect = new WeakMap();
_handleBlockDeselect = new WeakMap();
getEditorProductItem_fn = function(event) {
  var _a, _b;
  if (event.target instanceof Element) {
    const productItem = event.target.closest(PRODUCT_SELECTOR);
    if (productItem && ((_a = __privateGet(this, _root)) == null ? void 0 : _a.contains(productItem))) return productItem;
  }
  const blockId = (_b = event.detail) == null ? void 0 : _b.blockId;
  if (!blockId) return null;
  return __privateGet(this, _products).find((productItem) => {
    const editorData = productItem.getAttribute("data-shopify-editor-block");
    if (!editorData) return false;
    try {
      return JSON.parse(editorData).id === blockId;
    } catch {
      return false;
    }
  }) ?? null;
};
activateEditorProduct_fn = function(index) {
  var _a, _b, _c;
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, cancelSnap_fn).call(this);
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, cancelNavigationAnimation_fn).call(this);
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, releaseDesktopNavigationLock_fn).call(this);
  if (__privateGet(this, _scrubRAF)) cancelAnimationFrame(__privateGet(this, _scrubRAF));
  __privateSet(this, _scrubRAF, 0);
  if (__privateGet(this, _usesMobileCarousel)) {
    (_a = __privateGet(this, _mobileCarousel)) == null ? void 0 : _a.scrollTo(index, true);
    __privateGet(this, _syncMobileSelection).call(this);
    return;
  }
  if (!__privateGet(this, _usesScrollTrigger)) {
    (_b = __privateGet(this, _desktopCarousel)) == null ? void 0 : _b.scrollTo(index, true);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, cancelNavigationAnimation_fn).call(this);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtPosition_fn).call(this, index);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, releaseDesktopNavigationLock_fn).call(this);
    return;
  }
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, measure_fn).call(this);
  if (!__privateGet(this, _isMeasured)) return;
  const targetY = __privateGet(this, _startY) + __privateGet(this, _headHoldHeight) + index * __privateGet(this, _stepHeight);
  __privateSet(this, _currentScrollY, targetY);
  __privateSet(this, _targetScrollY, targetY);
  __privateSet(this, _scrubbedScrollY, targetY);
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtScroll_fn).call(this, targetY);
  const lenis = (_c = window.Theme) == null ? void 0 : _c.lenis;
  if (!__privateGet(this, _usesNativeScrub) && lenis) {
    lenis.scrollTo(targetY, { immediate: true, force: true });
  } else {
    window.scrollTo({ top: targetY, behavior: "instant" });
  }
};
_handleMobileBreakpointChange = new WeakMap();
setupDesktopCarousel_fn = function() {
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, destroyDesktopCarousel_fn).call(this);
  if (!__privateGet(this, _sticky) || __privateGet(this, _length) < 2) return;
  const engine = document.createElement("div");
  const viewport = document.createElement("div");
  const container = document.createElement("div");
  const fragment = document.createDocumentFragment();
  engine.className = DESKTOP_CAROUSEL_ENGINE_CLASS;
  engine.setAttribute("aria-hidden", "true");
  engine.inert = true;
  viewport.className = `${DESKTOP_CAROUSEL_ENGINE_CLASS}-viewport`;
  container.className = `${DESKTOP_CAROUSEL_ENGINE_CLASS}-container`;
  for (let index = 0; index < __privateGet(this, _length); index += 1) {
    const slide = document.createElement("div");
    slide.className = `${DESKTOP_CAROUSEL_ENGINE_CLASS}-slide`;
    fragment.appendChild(slide);
  }
  container.appendChild(fragment);
  viewport.appendChild(container);
  engine.appendChild(viewport);
  __privateGet(this, _sticky).appendChild(engine);
  __privateSet(this, _desktopCarouselEngine, engine);
  const plugins = [];
  if (__privateGet(this, _autoplayEnabled)) {
    plugins.push(
      Autoplay({
        delay: __privateGet(this, _autoplayDelay),
        playOnInit: false,
        stopOnInteraction: false
      })
    );
  }
  const carousel = EmblaCarousel(
    viewport,
    {
      align: "center",
      containScroll: false,
      duration: 25,
      loop: true,
      startIndex: clamp(__privateGet(this, _preferredIndex), 0, __privateGet(this, _length) - 1),
      watchDrag: false,
      watchResize: false,
      watchSlides: false
    },
    plugins
  );
  if (!carousel.internalEngine().slideLooper.canLoop()) {
    duplicateSlidesForLoop(carousel, container);
  }
  const scrollNext = carousel.scrollNext.bind(carousel);
  const scrollPrev = carousel.scrollPrev.bind(carousel);
  const scrollTo = carousel.scrollTo.bind(carousel);
  const runNavigation = (navigate, isAutoplay = false) => {
    if (!__privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, beginDesktopNavigation_fn).call(this)) return;
    const previousIndex = carousel.selectedScrollSnap();
    __privateSet(this, _isAutoplayNavigation, isAutoplay);
    navigate();
    if (carousel.selectedScrollSnap() === previousIndex) {
      __privateSet(this, _isAutoplayNavigation, false);
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, releaseDesktopNavigationLock_fn).call(this);
    }
  };
  carousel.scrollNext = (...args) => runNavigation(() => scrollNext(...args), __privateGet(this, _autoplayEnabled) && args.length > 0);
  carousel.scrollPrev = (...args) => runNavigation(() => scrollPrev(...args));
  carousel.scrollTo = (...args) => runNavigation(() => scrollTo(...args), __privateGet(this, _autoplayEnabled) && args.length > 1);
  carousel.on("select", __privateGet(this, _handleDesktopCarouselSelect));
  __privateSet(this, _desktopCarousel, carousel);
};
destroyDesktopCarousel_fn = function() {
  var _a;
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, releaseDesktopNavigationLock_fn).call(this);
  if (__privateGet(this, _desktopCarousel)) {
    __privateGet(this, _desktopCarousel).off("select", __privateGet(this, _handleDesktopCarouselSelect));
    __privateGet(this, _desktopCarousel).destroy();
    __privateSet(this, _desktopCarousel, null);
  }
  (_a = __privateGet(this, _desktopCarouselEngine)) == null ? void 0 : _a.remove();
  __privateSet(this, _desktopCarouselEngine, null);
};
_handleDesktopCarouselSelect = new WeakMap();
beginDesktopNavigation_fn = function() {
  if (__privateGet(this, _isNavigationLocked)) return false;
  __privateSet(this, _isNavigationLocked, true);
  clearTimeout(__privateGet(this, _navigationLockTimer));
  __privateSet(this, _navigationLockTimer, window.setTimeout(() => {
    __privateSet(this, _navigationLockTimer, 0);
    __privateSet(this, _isNavigationLocked, false);
  }, DESKTOP_NAVIGATION_LOCK_MS));
  return true;
};
releaseDesktopNavigationLock_fn = function() {
  clearTimeout(__privateGet(this, _navigationLockTimer));
  __privateSet(this, _navigationLockTimer, 0);
  __privateSet(this, _isNavigationLocked, false);
};
setupMobileCarousel_fn = function() {
  if (!__privateGet(this, _sticky) || !__privateGet(this, _productViewport) || !__privateGet(this, _productTrack)) return;
  const startIndex = clamp(__privateGet(this, _preferredIndex), 0, __privateGet(this, _length) - 1);
  const sharedProductColorScheme = __privateGet(this, _productViewport).dataset.syncedColorScheme ?? "";
  if (sharedProductColorScheme) {
    __privateGet(this, _productViewport).classList.remove(sharedProductColorScheme);
  }
  delete __privateGet(this, _productViewport).dataset.syncedColorScheme;
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, clearMotionStyles_fn).call(this);
  __privateGet(this, _products).forEach((productItem) => {
    productItem.inert = false;
    productItem.removeAttribute("aria-hidden");
  });
  __privateSet(this, _mobileCarousel, initNativeScroll(__privateGet(this, _productViewport), {
    align: "center",
    loop: __privateGet(this, _carouselLoop),
    startIndex
  }));
  __privateGet(this, _mobileCarousel).on("select", __privateGet(this, _syncMobileSelection));
  __privateGet(this, _mobileCarousel).on("reInit", __privateGet(this, _syncMobileSelection));
  __privateGet(this, _syncMobileSelection).call(this);
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setupControls_fn).call(this, __privateGet(this, _mobileCarousel));
};
destroyMobileCarousel_fn = function() {
  if (!__privateGet(this, _mobileCarousel)) return;
  __privateGet(this, _mobileCarousel).off("select", __privateGet(this, _syncMobileSelection));
  __privateGet(this, _mobileCarousel).off("reInit", __privateGet(this, _syncMobileSelection));
  __privateGet(this, _mobileCarousel).destroy();
  __privateSet(this, _mobileCarousel, null);
};
_syncMobileSelection = new WeakMap();
setupControls_fn = function(controlsApi = null, originalSlideCount = null) {
  var _a;
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, destroyControls_fn).call(this);
  const controls = (_a = __privateGet(this, _root)) == null ? void 0 : _a.querySelector(CONTROLS_SELECTOR);
  if (!controls || __privateGet(this, _length) < 2) return;
  __privateSet(this, _controlsApi, controlsApi ?? __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, createControlsApi_fn).call(this));
  const dots = controls.querySelector(".embla__snip-dots");
  const prevButton = controls.querySelector(".embla__snip-button--prev button");
  const nextButton = controls.querySelector(".embla__snip-button--next button");
  if (dots) {
    __privateGet(this, _controlsCleanup).push(addDotsBtnsAndClickHandlersSSR(__privateGet(this, _controlsApi), dots, originalSlideCount));
  }
  if (prevButton && nextButton) {
    __privateGet(this, _controlsCleanup).push(addPrevNextBtnsClickHandlersSSR(__privateGet(this, _controlsApi), prevButton, nextButton));
  }
  const selectedIndex = clamp(__privateGet(this, _activeIndex), 0, __privateGet(this, _length) - 1);
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, syncColorScheme_fn).call(this, selectedIndex);
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, syncAccessibility_fn).call(this, selectedIndex, false);
};
destroyControls_fn = function() {
  __privateGet(this, _controlsCleanup).splice(0).reverse().forEach((cleanup) => cleanup());
  __privateSet(this, _controlsApi, null);
};
setupCursorNavigation_fn = function() {
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, destroyCursorNavigation_fn).call(this);
  if (!__privateGet(this, _sticky) || __privateGet(this, _sticky).dataset.cursorNavigation !== "true" || __privateGet(this, _length) < 2) {
    return;
  }
  const mediaQuery = window.matchMedia(DESKTOP_FINE_POINTER_MEDIA_QUERY);
  const handleClick = (event) => {
    if (!mediaQuery.matches || !(event.target instanceof Element)) return;
    const navigationExclusion = event.target.closest(CURSOR_NAVIGATION_EXCLUSION_SELECTOR);
    if (navigationExclusion && __privateGet(this, _sticky).contains(navigationExclusion)) {
      return;
    }
    const rect = __privateGet(this, _sticky).getBoundingClientRect();
    const usesVerticalAxis = __privateGet(this, _sticky).dataset.cursorNavigationAxis === "vertical";
    const isPrevious = usesVerticalAxis ? event.clientY < rect.top + rect.height / 2 : event.clientX < rect.left + rect.width / 2;
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, navigateBy_fn).call(this, isPrevious ? -1 : 1);
  };
  __privateGet(this, _sticky).addEventListener("click", handleClick);
  __privateSet(this, _cursorNavigationCleanup, () => {
    var _a;
    (_a = __privateGet(this, _sticky)) == null ? void 0 : _a.removeEventListener("click", handleClick);
  });
};
destroyCursorNavigation_fn = function() {
  var _a;
  (_a = __privateGet(this, _cursorNavigationCleanup)) == null ? void 0 : _a.call(this);
  __privateSet(this, _cursorNavigationCleanup, null);
};
setupAutoplay_fn = function() {
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, destroyAutoplay_fn).call(this);
  if (!__privateGet(this, _autoplayEnabled) || !__privateGet(this, _sticky) || __privateGet(this, _length) < 2) return;
  __privateGet(this, _autoplayPauseReasons).add("viewport");
  document.addEventListener("visibilitychange", __privateGet(this, _handleAutoplayVisibilityChange));
  __privateSet(this, _autoplayObserver, new IntersectionObserver(([entry]) => {
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setAutoplayPaused_fn).call(this, "viewport", !(entry == null ? void 0 : entry.isIntersecting));
  }));
  __privateGet(this, _autoplayObserver).observe(__privateGet(this, _root));
};
destroyAutoplay_fn = function() {
  var _a, _b;
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, clearAutoplayTimer_fn).call(this);
  (_a = __privateGet(this, _autoplayObserver)) == null ? void 0 : _a.disconnect();
  __privateSet(this, _autoplayObserver, null);
  document.removeEventListener("visibilitychange", __privateGet(this, _handleAutoplayVisibilityChange));
  __privateGet(this, _autoplayPauseReasons).clear();
  (_b = __privateGet(this, _root)) == null ? void 0 : _b.classList.toggle("is-autoplay-paused", __privateGet(this, _autoplayEnabled));
};
_handleAutoplayVisibilityChange = new WeakMap();
setAutoplayPaused_fn = function(reason, paused) {
  if (paused) {
    __privateGet(this, _autoplayPauseReasons).add(reason);
  } else {
    __privateGet(this, _autoplayPauseReasons).delete(reason);
  }
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, scheduleAutoplay_fn).call(this);
};
scheduleAutoplay_fn = function() {
  var _a, _b, _c;
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, clearAutoplayTimer_fn).call(this);
  const autoplay = (_b = (_a = __privateGet(this, _desktopCarousel)) == null ? void 0 : _a.plugins()) == null ? void 0 : _b.autoplay;
  const canRun = Boolean(
    __privateGet(this, _autoplayEnabled) && autoplay && !__privateGet(this, _shouldReduceMotion) && __privateGet(this, _autoplayPauseReasons).size === 0 && !document.hidden && this.isConnected && __privateGet(this, _length) > 1 && !__privateGet(this, _navigationRAF)
  );
  (_c = __privateGet(this, _root)) == null ? void 0 : _c.classList.toggle("is-autoplay-paused", !canRun);
  if (!canRun) return;
  autoplay.play();
};
clearAutoplayTimer_fn = function() {
  var _a, _b, _c;
  (_c = (_b = (_a = __privateGet(this, _desktopCarousel)) == null ? void 0 : _a.plugins()) == null ? void 0 : _b.autoplay) == null ? void 0 : _c.stop();
  if (__privateGet(this, _autoplayTimer)) clearTimeout(__privateGet(this, _autoplayTimer));
  __privateSet(this, _autoplayTimer, 0);
  __privateSet(this, _autoplayDeadline, 0);
};
createControlsApi_fn = function() {
  const listeners = /* @__PURE__ */ new Map();
  const getSelectedIndex = () => clamp(__privateGet(this, _activeIndex), 0, __privateGet(this, _length) - 1);
  const autoplayPlugin = {
    options: { delay: __privateGet(this, _autoplayDelay) },
    timeUntilNext: () => __privateGet(this, _autoplayDeadline) > 0 ? Math.max(0, __privateGet(this, _autoplayDeadline) - performance.now()) : null,
    reset: () => __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, scheduleAutoplay_fn).call(this)
  };
  const api = {
    canScrollPrev: () => __privateGet(this, _carouselLoop) || getSelectedIndex() > 0,
    canScrollNext: () => __privateGet(this, _carouselLoop) || getSelectedIndex() < __privateGet(this, _length) - 1,
    scrollPrev: () => __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, navigateBy_fn).call(this, -1),
    scrollNext: () => __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, navigateBy_fn).call(this, 1),
    scrollTo: (index) => __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, navigateToIndex_fn).call(this, index),
    scrollSnapList: () => Array.from({ length: __privateGet(this, _length) }, (_, index) => index),
    selectedScrollSnap: getSelectedIndex,
    previousScrollSnap: () => __privateGet(this, _previousActiveIndex),
    plugins: () => __privateGet(this, _autoplayEnabled) ? { autoplay: autoplayPlugin } : {},
    internalEngine: () => ({
      options: { loop: __privateGet(this, _carouselLoop) }
    }),
    on: (eventName, callback) => {
      if (!listeners.has(eventName)) listeners.set(eventName, /* @__PURE__ */ new Set());
      listeners.get(eventName).add(callback);
      return api;
    },
    off: (eventName, callback) => {
      var _a;
      (_a = listeners.get(eventName)) == null ? void 0 : _a.delete(callback);
      return api;
    },
    emit: (eventName) => {
      var _a;
      (_a = listeners.get(eventName)) == null ? void 0 : _a.forEach((callback) => callback(api));
      return api;
    }
  };
  return api;
};
navigateBy_fn = function(step) {
  const direction = Math.sign(step);
  if (direction === 0) return;
  if (__privateGet(this, _desktopCarousel) && !__privateGet(this, _usesScrollTrigger)) {
    if (direction > 0) {
      __privateGet(this, _desktopCarousel).scrollNext();
    } else {
      __privateGet(this, _desktopCarousel).scrollPrev();
    }
    return;
  }
  const selectedIndex = clamp(__privateGet(this, _activeIndex), 0, __privateGet(this, _length) - 1);
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, navigateToIndex_fn).call(this, selectedIndex + direction);
};
navigateToIndex_fn = function(index) {
  if (__privateGet(this, _desktopCarousel) && !__privateGet(this, _usesScrollTrigger)) {
    const targetIndex2 = (Math.round(index) % __privateGet(this, _length) + __privateGet(this, _length)) % __privateGet(this, _length);
    __privateGet(this, _desktopCarousel).scrollTo(targetIndex2);
    return;
  }
  if (!__privateGet(this, _usesScrollTrigger)) {
    const selectedIndex = clamp(__privateGet(this, _activeIndex), 0, __privateGet(this, _length) - 1);
    const targetIndex2 = clamp(Math.round(index), 0, __privateGet(this, _length) - 1);
    if (__privateGet(this, _carouselLoop) && selectedIndex === 0 && (index < 0 || targetIndex2 === __privateGet(this, _length) - 1)) {
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, navigateWithoutScroll_fn).call(this, __privateGet(this, _length) - 1, false, -1);
    } else if (__privateGet(this, _carouselLoop) && selectedIndex === __privateGet(this, _length) - 1 && (index >= __privateGet(this, _length) || targetIndex2 === 0)) {
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, navigateWithoutScroll_fn).call(this, 0, false, 1);
    } else {
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, navigateWithoutScroll_fn).call(this, targetIndex2);
    }
    return;
  }
  if (!__privateGet(this, _isMeasured)) __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, measure_fn).call(this);
  if (!__privateGet(this, _isMeasured) || __privateGet(this, _length) < 2) return;
  const targetIndex = clamp(Math.round(index), 0, __privateGet(this, _length) - 1);
  const targetScrollY = __privateGet(this, _startY) + __privateGet(this, _headHoldHeight) + targetIndex * __privateGet(this, _stepHeight);
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, cancelSnap_fn).call(this);
  if (Math.abs(targetScrollY - __privateGet(this, _currentScrollY)) < 0.5) {
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtScroll_fn).call(this, targetScrollY);
    return;
  }
  if (__privateGet(this, _shouldReduceMotion)) {
    __privateSet(this, _currentScrollY, targetScrollY);
    __privateSet(this, _targetScrollY, targetScrollY);
    __privateSet(this, _scrubbedScrollY, targetScrollY);
    window.scrollTo({ top: targetScrollY, behavior: "instant" });
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtScroll_fn).call(this, targetScrollY);
    return;
  }
  const distanceInSegments = Math.abs(targetScrollY - __privateGet(this, _currentScrollY)) / __privateGet(this, _stepHeight);
  const duration = clamp(distanceInSegments * SNAP_DURATION_MAX_MS, SNAP_DURATION_MIN_MS, SNAP_DURATION_MAX_MS);
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, startSnap_fn).call(this, targetScrollY, duration);
};
navigateWithoutScroll_fn = function(index, immediate = false, wrapDirection = 0, isAutoplay = false) {
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, clearAutoplayTimer_fn).call(this);
  if (!__privateGet(this, _isMeasured) || __privateGet(this, _length) < 2) return;
  const targetIndex = clamp(Math.round(index), 0, __privateGet(this, _length) - 1);
  const startPosition = clamp(__privateGet(this, _renderedPosition) ?? __privateGet(this, _activeIndex) ?? 0, 0, __privateGet(this, _length) - 1);
  const usesForwardWrap = Boolean(
    wrapDirection > 0 && targetIndex === 0 && startPosition >= __privateGet(this, _length) - 1 - 1e-4
  );
  const usesBackwardWrap = Boolean(wrapDirection < 0 && targetIndex === __privateGet(this, _length) - 1 && startPosition <= 1e-4);
  const activeWrapDirection = usesForwardWrap ? 1 : usesBackwardWrap ? -1 : 0;
  const animationTarget = usesForwardWrap ? __privateGet(this, _length) : usesBackwardWrap ? -1 : targetIndex;
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, cancelNavigationAnimation_fn).call(this);
  __privateSet(this, _isAutoplayNavigation, isAutoplay);
  if (immediate || __privateGet(this, _shouldReduceMotion) || Math.abs(animationTarget - startPosition) < 1e-4) {
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtPosition_fn).call(this, targetIndex);
    __privateSet(this, _isAutoplayNavigation, false);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, releaseDesktopNavigationLock_fn).call(this);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, scheduleAutoplay_fn).call(this);
    return;
  }
  const direction = animationTarget > startPosition ? 1 : -1;
  const transitionStops = [startPosition];
  let nextBoundary = direction > 0 ? Math.floor(startPosition) + 1 : Math.ceil(startPosition) - 1;
  while (direction > 0 ? nextBoundary < animationTarget : nextBoundary > animationTarget) {
    transitionStops.push(nextBoundary);
    nextBoundary += direction;
  }
  transitionStops.push(animationTarget);
  let elapsedOffset = 0;
  const totalDistance = Math.abs(animationTarget - startPosition);
  const transitionLegs = transitionStops.slice(0, -1).map((legStart, legIndex) => {
    const legEnd = transitionStops[legIndex + 1];
    const duration = Math.abs(legEnd - legStart) / totalDistance * SLIDESHOW_TRANSITION_DURATION_MS;
    const leg = { start: legStart, end: legEnd, duration, elapsedOffset };
    elapsedOffset += duration;
    return leg;
  });
  const totalDuration = elapsedOffset;
  const transitionEasing = __privateGet(this, _backgroundTransitionStyle) === "wipe" ? easeSlideshowWipeTransition : easeSlideshowTransition;
  const generation = ++__privateWrapper(this, _navigationGeneration)._;
  const startTime = performance.now();
  const update = (timestamp) => {
    if (generation !== __privateGet(this, _navigationGeneration)) return;
    const elapsed = clamp(timestamp - startTime, 0, totalDuration);
    const activeLeg = transitionLegs.find(({ elapsedOffset: offset, duration }) => elapsed < offset + duration) ?? transitionLegs[transitionLegs.length - 1];
    const legProgress = clamp((elapsed - activeLeg.elapsedOffset) / activeLeg.duration, 0, 1);
    const position = activeLeg.start + (activeLeg.end - activeLeg.start) * transitionEasing(legProgress);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtPosition_fn).call(this, position, activeWrapDirection);
    if (elapsed < totalDuration) {
      __privateSet(this, _navigationRAF, requestAnimationFrame(update));
    } else {
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtPosition_fn).call(this, targetIndex);
      __privateSet(this, _navigationRAF, 0);
      __privateSet(this, _isAutoplayNavigation, false);
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, scheduleAutoplay_fn).call(this);
    }
  };
  __privateSet(this, _navigationRAF, requestAnimationFrame(update));
};
cancelNavigationAnimation_fn = function() {
  __privateSet(this, _navigationGeneration, __privateGet(this, _navigationGeneration) + 1);
  if (__privateGet(this, _navigationRAF)) cancelAnimationFrame(__privateGet(this, _navigationRAF));
  __privateSet(this, _navigationRAF, 0);
  __privateSet(this, _isAutoplayNavigation, false);
};
_scheduleMeasure = new WeakMap();
measure_fn = function() {
  var _a, _b;
  if (!__privateGet(this, _root) || !__privateGet(this, _sticky) || !__privateGet(this, _step)) return;
  const rootRect = __privateGet(this, _root).getBoundingClientRect();
  const stepRect = __privateGet(this, _step).getBoundingClientRect();
  const headHoldRect = (_a = __privateGet(this, _headHold)) == null ? void 0 : _a.getBoundingClientRect();
  const tailHoldRect = (_b = __privateGet(this, _tailHold)) == null ? void 0 : _b.getBoundingClientRect();
  const stickyRect = __privateGet(this, _sticky).getBoundingClientRect();
  const stickyStyles = getComputedStyle(__privateGet(this, _sticky));
  const stickyTop = parseFloat(stickyStyles.top) || 0;
  const scrollY = window.scrollY ?? __privateGet(this, _currentScrollY);
  __privateSet(this, _currentStickyHeight, stickyRect.height);
  if (__privateGet(this, _usesFirstSectionHeightCompensation)) {
    const rootStyles = getComputedStyle(document.documentElement);
    const rootFontSize = Number.parseFloat(rootStyles.fontSize) || 16;
    const pageMarginValue = stickyStyles.getPropertyValue("--sticky-viewport-page-margin") || rootStyles.getPropertyValue("--page-margin");
    const pageMargin = parseCssLengthToPixels(pageMarginValue, rootFontSize) ?? 0;
    const viewportHeight = window.innerHeight;
    const viewportKey = `${Math.round(window.innerWidth)}:${Math.round(viewportHeight)}`;
    const header = document.querySelector("header-v3-component");
    const headerIsSticky = (header == null ? void 0 : header.dataset.sticky) === "true";
    const headerStickyMode = (header == null ? void 0 : header.dataset.stickyMode) || "always";
    const headerPosition = (header == null ? void 0 : header.dataset.position) || "outside";
    const tallStickyHeight = Math.max(0, viewportHeight - pageMargin * 2);
    if (headerIsSticky && headerStickyMode === "always") {
      const headerSurface = header.querySelector(".header-v3");
      const measuredHeaderHeight = headerSurface == null ? void 0 : headerSurface.getBoundingClientRect().height;
      const cssHeaderHeight = parseCssLengthToPixels(
        stickyStyles.getPropertyValue("--sticky-viewport-header-height"),
        rootFontSize
      );
      const headerHeight = Number.isFinite(measuredHeaderHeight) ? measuredHeaderHeight : cssHeaderHeight ?? 0;
      const sectionGap = parseCssLengthToPixels(rootStyles.getPropertyValue("--section-gap"), rootFontSize) ?? 0;
      const visibleHeaderGap = Math.min(sectionGap, pageMargin);
      __privateSet(this, _targetStickyHeight, Math.max(0, viewportHeight - headerHeight - visibleHeaderGap - pageMargin));
    } else {
      __privateSet(this, _targetStickyHeight, tallStickyHeight);
    }
    const modeKey = [
      headerIsSticky,
      headerStickyMode,
      headerPosition,
      Math.round(pageMargin * 100) / 100,
      Math.round(__privateGet(this, _targetStickyHeight) * 100) / 100
    ].join(":");
    if (viewportKey !== __privateGet(this, _heightCompensationViewportKey) || modeKey !== __privateGet(this, _heightCompensationModeKey)) {
      __privateSet(this, _referenceStickyHeight, 0);
      __privateSet(this, _heightCompensationViewportKey, viewportKey);
      __privateSet(this, _heightCompensationModeKey, modeKey);
    }
    __privateSet(this, _referenceStickyHeight, Math.max(
      __privateGet(this, _referenceStickyHeight),
      __privateGet(this, _currentStickyHeight),
      __privateGet(this, _targetStickyHeight)
    ));
  } else {
    __privateSet(this, _targetStickyHeight, __privateGet(this, _currentStickyHeight));
    __privateSet(this, _referenceStickyHeight, __privateGet(this, _currentStickyHeight));
  }
  __privateSet(this, _currentScrollY, scrollY);
  __privateSet(this, _targetScrollY, scrollY);
  if (!__privateGet(this, _isMeasured)) __privateSet(this, _scrubbedScrollY, scrollY);
  __privateSet(this, _startY, rootRect.top + scrollY - stickyTop);
  __privateSet(this, _stepHeight, Math.max(1, stepRect.height));
  __privateSet(this, _headHoldHeight, Math.max(0, (headHoldRect == null ? void 0 : headHoldRect.height) ?? 0));
  __privateSet(this, _tailHoldHeight, Math.max(0, (tailHoldRect == null ? void 0 : tailHoldRect.height) ?? 0));
  __privateSet(this, _isMeasured, true);
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtScroll_fn).call(this, __privateGet(this, _usesNativeScrub) ? __privateGet(this, _scrubbedScrollY) : scrollY);
};
scheduleScrollStopFallback_fn = function() {
  clearTimeout(__privateGet(this, _scrollStopTimer));
  __privateSet(this, _scrollStopTimer, setTimeout(() => {
    __privateSet(this, _scrollStopTimer, 0);
    __privateGet(this, _handleScrollEnd).call(this);
  }, SCROLL_STOP_FALLBACK_MS));
};
isWithinTimelineRange_fn = function(scrollY) {
  if (!__privateGet(this, _isMeasured) || __privateGet(this, _length) < 2) return false;
  const travel = __privateGet(this, _headHoldHeight) + __privateGet(this, _stepHeight) * (__privateGet(this, _length) - 1) + __privateGet(this, _tailHoldHeight);
  return scrollY >= __privateGet(this, _startY) && scrollY <= __privateGet(this, _startY) + travel;
};
scheduleNativeScrub_fn = function() {
  if (__privateGet(this, _scrubRAF)) return;
  __privateSet(this, _scrubLastTime, performance.now());
  __privateSet(this, _scrubRAF, requestAnimationFrame(__privateGet(this, _updateNativeScrub)));
};
_updateNativeScrub = new WeakMap();
snapToDirectionalCheckpoint_fn = function() {
  if (!__privateGet(this, _isMeasured) || __privateGet(this, _isSnapping) || __privateGet(this, _shouldReduceMotion) || __privateGet(this, _length) < 2) {
    return;
  }
  const segmentCount = __privateGet(this, _length) - 1;
  const transitionStartY = __privateGet(this, _startY) + __privateGet(this, _headHoldHeight);
  const transitionTravel = __privateGet(this, _stepHeight) * segmentCount;
  const transitionEndY = transitionStartY + transitionTravel;
  const timelineTravel = __privateGet(this, _headHoldHeight) + transitionTravel + __privateGet(this, _tailHoldHeight);
  const progress = (__privateGet(this, _currentScrollY) - __privateGet(this, _startY)) / timelineTravel;
  if (progress <= 0 || progress >= 1) return;
  const isLeavingAtStart = __privateGet(this, _lastScrollDirection) === "up" && __privateGet(this, _currentScrollY) <= transitionStartY;
  const isLeavingAtEnd = __privateGet(this, _lastScrollDirection) === "down" && __privateGet(this, _currentScrollY) >= transitionEndY;
  if (isLeavingAtStart || isLeavingAtEnd) return;
  const linearPosition = clamp((__privateGet(this, _currentScrollY) - transitionStartY) / __privateGet(this, _stepHeight), 0, segmentCount);
  const nearestIndex = Math.round(linearPosition);
  let targetIndex = nearestIndex;
  if (Math.abs(linearPosition - nearestIndex) > SNAP_CHECKPOINT_EPSILON) {
    if (__privateGet(this, _lastScrollDirection) === "down") {
      targetIndex = Math.ceil(linearPosition);
    } else if (__privateGet(this, _lastScrollDirection) === "up") {
      targetIndex = Math.floor(linearPosition);
    }
  }
  targetIndex = clamp(targetIndex, 0, segmentCount);
  const targetScrollY = transitionStartY + targetIndex * __privateGet(this, _stepHeight);
  const distanceInSegments = Math.abs(targetScrollY - __privateGet(this, _currentScrollY)) / __privateGet(this, _stepHeight);
  const duration = clamp(distanceInSegments * SNAP_DURATION_MAX_MS, SNAP_DURATION_MIN_MS, SNAP_DURATION_MAX_MS);
  if (Math.abs(targetScrollY - __privateGet(this, _currentScrollY)) < 0.5) return;
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, startSnap_fn).call(this, targetScrollY, duration);
};
startSnap_fn = function(targetScrollY, duration) {
  var _a;
  __privateSet(this, _isSnapping, true);
  const generation = ++__privateWrapper(this, _snapGeneration)._;
  const startScrollY = __privateGet(this, _currentScrollY);
  const lenis = (_a = window.Theme) == null ? void 0 : _a.lenis;
  if (!__privateGet(this, _usesNativeScrub) && lenis) {
    lenis.scrollTo(targetScrollY, {
      duration: duration / 1e3,
      // Strictly monotonic: no elastic/back easing or overshoot.
      easing: easePower3Out,
      onComplete: () => __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, finishSnap_fn).call(this, generation, targetScrollY)
    });
    return;
  }
  const startTime = performance.now();
  const update = (timestamp) => {
    if (generation !== __privateGet(this, _snapGeneration)) return;
    const progress = clamp((timestamp - startTime) / duration, 0, 1);
    const scrollY = startScrollY + (targetScrollY - startScrollY) * easePower3Out(progress);
    window.scrollTo({ top: scrollY, behavior: "instant" });
    if (progress < 1) {
      __privateSet(this, _snapRAF, requestAnimationFrame(update));
    } else {
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, finishSnap_fn).call(this, generation, targetScrollY);
    }
  };
  __privateSet(this, _snapRAF, requestAnimationFrame(update));
};
finishSnap_fn = function(generation, targetScrollY) {
  if (generation !== __privateGet(this, _snapGeneration)) return;
  __privateSet(this, _snapRAF, 0);
  __privateSet(this, _isSnapping, false);
  __privateSet(this, _currentScrollY, targetScrollY);
  __privateSet(this, _targetScrollY, targetScrollY);
  if (__privateGet(this, _usesNativeScrub) && !__privateGet(this, _shouldReduceMotion)) {
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, scheduleNativeScrub_fn).call(this);
  } else {
    __privateSet(this, _scrubbedScrollY, targetScrollY);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtScroll_fn).call(this, targetScrollY);
  }
};
cancelSnap_fn = function() {
  var _a;
  clearTimeout(__privateGet(this, _snapDelayTimer));
  __privateSet(this, _snapDelayTimer, 0);
  if (!__privateGet(this, _isSnapping)) return;
  __privateSet(this, _isSnapping, false);
  __privateSet(this, _snapGeneration, __privateGet(this, _snapGeneration) + 1);
  if (__privateGet(this, _snapRAF)) cancelAnimationFrame(__privateGet(this, _snapRAF));
  __privateSet(this, _snapRAF, 0);
  const lenis = (_a = window.Theme) == null ? void 0 : _a.lenis;
  if (lenis && !__privateGet(this, _usesNativeScrub)) {
    const scrollY = lenis.scroll ?? window.scrollY ?? __privateGet(this, _currentScrollY);
    lenis.scrollTo(scrollY, { immediate: true, force: true });
  }
};
renderAtScroll_fn = function(scrollY) {
  if (__privateGet(this, _length) === 0) return;
  if (__privateGet(this, _isEditorScrollSyncing)) {
    const editorSelectedIndex = __privateGet(this, _editorPreviewIndex);
    if (Number.isInteger(editorSelectedIndex) && editorSelectedIndex >= 0 && editorSelectedIndex < __privateGet(this, _length)) {
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtPosition_fn).call(this, editorSelectedIndex);
      return;
    }
  }
  const segmentCount = Math.max(0, __privateGet(this, _length) - 1);
  const transitionStartY = __privateGet(this, _startY) + __privateGet(this, _headHoldHeight);
  const transitionTravel = __privateGet(this, _stepHeight) * Math.max(1, segmentCount);
  const masterProgress = clamp((scrollY - transitionStartY) / transitionTravel, 0, 1);
  const position = getTimelinePosition(masterProgress, __privateGet(this, _length));
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, renderAtPosition_fn).call(this, position);
};
renderAtPosition_fn = function(position, wrapDirection = 0) {
  if (__privateGet(this, _length) === 0) return;
  const isWrapping = wrapDirection !== 0;
  const activeIndex = isWrapping ? (Math.round(position) % __privateGet(this, _length) + __privateGet(this, _length)) % __privateGet(this, _length) : Math.round(position);
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, syncActiveState_fn).call(this, activeIndex);
  if (__privateGet(this, _shouldReduceMotion)) {
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, clearMotionStyles_fn).call(this);
    return;
  }
  const renderedPosition = Math.round(position * 1e4) / 1e4;
  const heightCompensation = __privateGet(this, _usesFirstSectionHeightCompensation) && __privateGet(this, _currentStickyHeight) > 0 && __privateGet(this, _referenceStickyHeight) > 0 ? Math.max(1, __privateGet(this, _referenceStickyHeight) / __privateGet(this, _currentStickyHeight)) : 1;
  const renderedHeightCompensation = Math.round(heightCompensation * 1e4) / 1e4;
  if (renderedPosition === __privateGet(this, _renderedPosition) && renderedHeightCompensation === __privateGet(this, _renderedHeightCompensation)) {
    return;
  }
  const previousRenderedPosition = __privateGet(this, _renderedPosition);
  __privateSet(this, _renderedPosition, renderedPosition);
  __privateSet(this, _renderedHeightCompensation, renderedHeightCompensation);
  const transitionDirection = isWrapping ? wrapDirection : previousRenderedPosition === null || renderedPosition === previousRenderedPosition ? __privateGet(this, _lastScrollDirection) === "up" ? -1 : 1 : renderedPosition > previousRenderedPosition ? 1 : -1;
  const wipeSegmentStart = isWrapping ? __privateGet(this, _length) - 1 : Math.floor(renderedPosition);
  const wipeSegmentEnd = isWrapping ? 0 : Math.min(wipeSegmentStart + 1, __privateGet(this, _length) - 1);
  const wipeSegmentProgress = wrapDirection > 0 ? renderedPosition - (__privateGet(this, _length) - 1) : wrapDirection < 0 ? renderedPosition + 1 : renderedPosition - wipeSegmentStart;
  const wipeIsAtFinalItem = !isWrapping && wipeSegmentStart === wipeSegmentEnd;
  const wipeIncomingIndex = transitionDirection > 0 ? wipeSegmentEnd : wipeSegmentStart;
  const wipeOutgoingIndex = transitionDirection > 0 ? wipeSegmentStart : wipeSegmentEnd;
  const wipeProgress = wipeIsAtFinalItem ? 1 : transitionDirection > 0 ? wipeSegmentProgress : 1 - wipeSegmentProgress;
  const usesCrossfade = BACKGROUND_CROSSFADE_STYLES.has(__privateGet(this, _backgroundTransitionStyle));
  const usesWipe = __privateGet(this, _backgroundTransitionStyle) === "wipe";
  const slideUsesVerticalAxis = __privateGet(this, _backgroundTransitionStyle) === "slide" && __privateGet(this, _backgroundSlideAxis) === "vertical";
  for (let index = 0; index < __privateGet(this, _length); index += 1) {
    const offset = wrapDirection > 0 && index === 0 ? __privateGet(this, _length) - renderedPosition : wrapDirection < 0 && index === __privateGet(this, _length) - 1 ? -1 - renderedPosition : index - renderedPosition;
    const distance = Math.abs(offset);
    const visible = distance < 1;
    const translate = Math.round(clamp(offset, -1, 1) * 1e4) / 100;
    const backgroundOpacity = Math.round((1 - clamp(distance, 0, 1)) * 1e4) / 1e4;
    const clampedDistance = clamp(distance, 0, 1);
    let transitionScale = BACKGROUND_SETTLED_SCALE;
    if (__privateGet(this, _backgroundTransitionStyle) === "slide" || __privateGet(this, _backgroundTransitionStyle) === "scale" || __privateGet(this, _backgroundTransitionStyle) === "vertical") {
      transitionScale += clampedDistance * (BACKGROUND_STANDARD_ENTRY_SCALE - BACKGROUND_SETTLED_SCALE);
    } else if (usesWipe && index === wipeIncomingIndex) {
      transitionScale = BACKGROUND_WIPE_ENTRY_SCALE - clamp(wipeProgress, 0, 1) * (BACKGROUND_WIPE_ENTRY_SCALE - BACKGROUND_SETTLED_SCALE);
    }
    const backgroundScale = Math.round(transitionScale * renderedHeightCompensation * 1e4) / 1e4;
    const zIndex = usesWipe ? index === wipeIncomingIndex ? "3" : index === wipeOutgoingIndex ? "2" : "1" : usesCrossfade ? String(index + 1) : index === activeIndex ? "3" : "2";
    const { element: productItem, media, info } = __privateGet(this, _productData)[index];
    const {
      element: backgroundItem,
      overflow: backgroundOverflow,
      media: backgroundMedia
    } = __privateGet(this, _backgroundData)[index];
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setStyle_fn).call(this, productItem, "visibility", visible ? "visible" : "hidden");
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, syncProductColorTransitionTarget_fn).call(this, productItem, visible);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setStyle_fn).call(this, backgroundItem, "visibility", visible ? "visible" : "hidden");
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setStyle_fn).call(this, backgroundItem, "z-index", visible ? zIndex : "1");
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setStyle_fn).call(this, backgroundItem, "opacity", usesCrossfade ? String(backgroundOpacity) : "1");
    if (backgroundOverflow) {
      let clipPath = "inset(0)";
      if (usesWipe && index === wipeIncomingIndex) {
        const hiddenPercent = Math.round((1 - clamp(wipeProgress, 0, 1)) * 1e4) / 100;
        clipPath = transitionDirection > 0 ? `inset(${hiddenPercent}% 0 0 0)` : `inset(0 0 ${hiddenPercent}% 0)`;
      } else if (usesWipe && index !== wipeOutgoingIndex) {
        clipPath = "inset(100% 0 0 0)";
      }
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setStyle_fn).call(this, backgroundOverflow, "clip-path", clipPath);
    }
    if (backgroundMedia) {
      const mediaTranslate = __privateGet(this, _backgroundTransitionStyle) === "slide" || __privateGet(this, _backgroundTransitionStyle) === "vertical" ? Math.round(clampedDistance * 500) / 100 : 0;
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setStyle_fn).call(this, backgroundMedia, "transform", __privateGet(this, _backgroundTransitionStyle) === "slide" ? slideUsesVerticalAxis ? `translate3d(0, ${mediaTranslate}%, 0) scale(${backgroundScale})` : `translate3d(${mediaTranslate}%, 0, 0) scale(${backgroundScale})` : __privateGet(this, _backgroundTransitionStyle) === "vertical" ? `translate3d(0, ${-mediaTranslate}%, 0) scale(${backgroundScale})` : `translate3d(0, 0, 0) scale(${backgroundScale})`);
    }
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setStyle_fn).call(this, backgroundItem, "transform", __privateGet(this, _backgroundTransitionStyle) === "slide" ? slideUsesVerticalAxis ? `translate3d(0, ${translate}%, 0)` : `translate3d(${translate}%, 0, 0)` : "translate3d(0, 0, 0)");
    if (media) {
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setStyle_fn).call(this, media, "transform", `translate3d(0, ${translate}%, 0)`);
    }
    if (info) {
      __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, setStyle_fn).call(this, info, "transform", `translate3d(0, ${-translate}%, 0)`);
    }
  }
};
syncActiveState_fn = function(activeIndex) {
  var _a, _b;
  if (activeIndex === __privateGet(this, _activeIndex)) return;
  const shouldAnnounce = __privateGet(this, _activeIndex) >= 0 && !__privateGet(this, _isAutoplayNavigation);
  __privateSet(this, _previousActiveIndex, __privateGet(this, _activeIndex) < 0 ? activeIndex : __privateGet(this, _activeIndex));
  __privateSet(this, _activeIndex, activeIndex);
  __privateSet(this, _preferredIndex, activeIndex);
  __privateGet(this, _products).forEach((productItem, index) => {
    const isActive = index === activeIndex;
    productItem.classList.toggle("is-active", isActive);
    productItem.inert = !isActive;
    if (isActive) {
      productItem.removeAttribute("aria-hidden");
    } else {
      productItem.setAttribute("aria-hidden", "true");
    }
  });
  __privateGet(this, _backgroundData).forEach(({ element: backgroundItem, parallax }, index) => {
    var _a2, _b2, _c;
    const isActive = index === activeIndex;
    backgroundItem.classList.toggle("is-active", isActive);
    backgroundItem.querySelectorAll('custom-video[data-background-video="true"]').forEach((video) => {
      if (isActive) {
        if (typeof video.playMedia === "function") video.playMedia();
        else video.dataset.playbackActive = "true";
      } else if (typeof video.pauseMedia === "function") {
        video.pauseMedia();
      } else {
        video.dataset.playbackActive = "false";
      }
    });
    if (!parallax || __privateGet(this, _usesMobileCarousel) || isMobileAnim) return;
    const inner = parallax.querySelector(".media-bg-block-content");
    if (isActive) {
      parallax.classList.add("active");
      parallax.dataset.deferParallax = "false";
      if (inner) inner.style.animationPlayState = "";
      (_a2 = parallax._enableEffects) == null ? void 0 : _a2.call(parallax);
      (_b2 = parallax.enableParallax) == null ? void 0 : _b2.call(parallax);
    } else {
      if (inner) inner.style.animationPlayState = "paused";
      (_c = parallax.disableParallax) == null ? void 0 : _c.call(parallax);
      parallax.dataset.deferParallax = "true";
    }
  });
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, syncColorScheme_fn).call(this, activeIndex);
  __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, syncAccessibility_fn).call(this, activeIndex, shouldAnnounce);
  if (!__privateGet(this, _desktopCarousel)) {
    (_a = __privateGet(this, _controlsApi)) == null ? void 0 : _a.emit("select");
  }
  if (__privateGet(this, _autoplayEnabled) && !__privateGet(this, _desktopCarousel)) {
    (_b = __privateGet(this, _controlsApi)) == null ? void 0 : _b.emit("autoplay:reset");
  }
};
syncColorScheme_fn = function(activeIndex) {
  var _a, _b, _c, _d;
  const activeProduct = __privateGet(this, _products)[activeIndex];
  const backgroundColorScheme = ((_a = activeProduct == null ? void 0 : activeProduct.dataset.colorScheme) == null ? void 0 : _a.trim()) ?? "";
  const productCardColorScheme = ((_b = activeProduct == null ? void 0 : activeProduct.dataset.productCardColorScheme) == null ? void 0 : _b.trim()) ?? "";
  const shouldSyncContentGroup = ((_c = __privateGet(this, _contentGroup)) == null ? void 0 : _c.dataset.autoColorScheme) !== "false";
  const targets = [
    {
      target: __privateGet(this, _usesMobileCarousel) ? null : __privateGet(this, _productViewport),
      colorScheme: productCardColorScheme
    },
    {
      target: shouldSyncContentGroup ? __privateGet(this, _contentGroup) : null,
      colorScheme: backgroundColorScheme
    },
    {
      target: (_d = __privateGet(this, _root)) == null ? void 0 : _d.querySelector(CONTROLS_SELECTOR),
      colorScheme: backgroundColorScheme
    }
  ].filter(({ target }) => target);
  targets.forEach(({ target, colorScheme }) => {
    const previousColorScheme = target.dataset.syncedColorScheme ?? "";
    const baseColorScheme = target.dataset.baseColorScheme ?? "";
    if (previousColorScheme && previousColorScheme !== colorScheme) {
      target.classList.remove(previousColorScheme);
    }
    if (baseColorScheme) {
      target.classList.toggle(baseColorScheme, colorScheme === "");
    }
    if (colorScheme) {
      target.classList.add(colorScheme);
      target.dataset.syncedColorScheme = colorScheme;
    } else {
      delete target.dataset.syncedColorScheme;
    }
  });
  if (__privateGet(this, _sticky)) {
    if (backgroundColorScheme) {
      __privateGet(this, _sticky).dataset.cursorColorScheme = backgroundColorScheme;
    } else {
      delete __privateGet(this, _sticky).dataset.cursorColorScheme;
    }
  }
  if (backgroundColorScheme !== __privateGet(this, _syncedColorScheme)) {
    __privateSet(this, _syncedColorScheme, backgroundColorScheme);
    window.dispatchEvent(new CustomEvent("cursor:update"));
  }
};
syncAccessibility_fn = function(activeIndex, announce) {
  var _a, _b;
  const dots = ((_a = __privateGet(this, _root)) == null ? void 0 : _a.querySelectorAll(".embla__dot")) ?? [];
  dots.forEach((dot, index) => {
    if (index === activeIndex) {
      dot.setAttribute("aria-current", "true");
    } else {
      dot.removeAttribute("aria-current");
    }
  });
  if (announce && __privateGet(this, _slideStatus)) {
    __privateGet(this, _slideStatus).textContent = ((_b = __privateGet(this, _products)[activeIndex]) == null ? void 0 : _b.dataset.slideLabel) ?? "";
  }
};
resetSynchronizedState_fn = function() {
  var _a, _b, _c;
  const shouldSyncContentGroup = ((_a = __privateGet(this, _contentGroup)) == null ? void 0 : _a.dataset.autoColorScheme) !== "false";
  const targets = [
    __privateGet(this, _productViewport),
    shouldSyncContentGroup ? __privateGet(this, _contentGroup) : null,
    (_b = __privateGet(this, _root)) == null ? void 0 : _b.querySelector(CONTROLS_SELECTOR)
  ].filter(Boolean);
  targets.forEach((target) => {
    const colorScheme = target.dataset.syncedColorScheme ?? "";
    const baseColorScheme = target.dataset.baseColorScheme ?? "";
    if (colorScheme) target.classList.remove(colorScheme);
    if (baseColorScheme) target.classList.add(baseColorScheme);
    delete target.dataset.syncedColorScheme;
  });
  (_c = __privateGet(this, _root)) == null ? void 0 : _c.querySelectorAll(".embla__dot").forEach((dot) => {
    dot.removeAttribute("aria-current");
  });
  if (__privateGet(this, _slideStatus)) __privateGet(this, _slideStatus).textContent = "";
  if (__privateGet(this, _sticky)) delete __privateGet(this, _sticky).dataset.cursorColorScheme;
  __privateGet(this, _products).forEach((productItem) => {
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, syncProductColorTransitionTarget_fn).call(this, productItem, false);
  });
  __privateSet(this, _syncedColorScheme, null);
};
syncProductColorTransitionTarget_fn = function(productItem, isVisible) {
  const shouldTransition = isVisible && !__privateGet(this, _usesMobileCarousel);
  const isTransitionTarget = productItem.classList.contains(PRODUCT_COLOR_TRANSITION_CLASS);
  if (shouldTransition) {
    if (!isTransitionTarget) {
      productItem.classList.add(PRODUCT_COLOR_TRANSITION_CLASS);
    }
    return;
  }
  if (isTransitionTarget) {
    productItem.classList.remove(PRODUCT_COLOR_TRANSITION_CLASS);
  }
};
clearMotionStyles_fn = function() {
  __privateSet(this, _renderedPosition, null);
  __privateSet(this, _renderedHeightCompensation, null);
  __privateGet(this, _productData).forEach(({ element, media, info }) => {
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, syncProductColorTransitionTarget_fn).call(this, element, false);
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, clearStyle_fn).call(this, element, "visibility");
    if (media) __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, clearStyle_fn).call(this, media, "transform");
    if (info) __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, clearStyle_fn).call(this, info, "transform");
  });
  __privateGet(this, _backgroundData).forEach(({ element: backgroundItem, overflow, media }) => {
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, clearStyle_fn).call(this, backgroundItem, "visibility");
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, clearStyle_fn).call(this, backgroundItem, "z-index");
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, clearStyle_fn).call(this, backgroundItem, "opacity");
    __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, clearStyle_fn).call(this, backgroundItem, "transform");
    if (overflow) __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, clearStyle_fn).call(this, overflow, "clip-path");
    if (media) __privateMethod(this, _SCFeaturedProductsSlideshowComponent_instances, clearStyle_fn).call(this, media, "transform");
  });
};
setStyle_fn = function(element, property, value) {
  if (element.style.getPropertyValue(property) === value) return;
  element.style.setProperty(property, value);
};
clearStyle_fn = function(element, property) {
  if (!element.style.getPropertyValue(property)) return;
  element.style.removeProperty(property);
};
if (!customElements.get("sc-featured-products-slideshow-component")) {
  customElements.define("sc-featured-products-slideshow-component", SCFeaturedProductsSlideshowComponent);
}
